import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SubjectEntity } from "../../services/subjects/subjects.types";

export type SubjectState = {
  subjects: SubjectEntity[];
  loading: boolean;
};

const initialState: SubjectState = {
  subjects: [],
  loading: false,
};

const subject = createSlice({
  name: "subject",
  initialState,
  reducers: {
    clearSubject: (state) => {
      state.subjects = [];
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSubjects: (state, action: PayloadAction<SubjectEntity[]>) => {
      state.subjects = action.payload;
      state.loading = false;
    },
    addSubject: (state, action: PayloadAction<SubjectEntity>) => {
      state.subjects.unshift(action.payload);
    },
    updateSubject: (
      state,
      action: PayloadAction<{ id: number; data: SubjectEntity }>
    ) => {
      const index = state.subjects.findIndex(
        (subject) => subject.id === action.payload.id
      );
      if (index !== -1) {
        state.subjects[index] = action.payload.data;
      }
    },
    deleteSubject: (state, action: PayloadAction<number>) => {
      state.subjects = state.subjects.filter(
        (subject) => subject.id !== action.payload
      );
    },
  },
});

export default subject;
export const {
  clearSubject,
  setSubjects,
  setLoading,
  addSubject,
  updateSubject,
  deleteSubject,
} = subject.actions;
